<template>
  <donut-chart-card
    title="중대시민재해 발생 현황"
    :value="data"
    unit="건"
    :isMoveWrite="isMoveWrite"
    :orientation="orientation"
    @detail="onClickDetail"
    @write="onClickWrite"
  ></donut-chart-card>
</template>

<script>
import DonutChartCard from '@/components/DonutChartCard'
import CircleGraphUtil from '@/util/CircleGraphUtil'
export default {
  name: 'DonutChart14',
  components: {DonutChartCard},
  props: {
    dataType: 'detail' | 'field' | 'address' | 'field_cat1' | 'company' | 'project',
    orientation: {
      type: "landscape" | "portrait",
      default: () => "portrait"
    },
  },
  computed: {
    projectId () {
      return this.$route.params.proj_id
    },
    isMoveWrite () {
      // if (Number(`${this.projectId}`) === 1) return false
      // else return true
      return true
    }
  },
  watch: {
    dataType (value) {
      this.loadGraph()
    }
  },
  data () {
    return {
      graphId: 14,
      boardIds: [244],
      summaryKeys: {
        'detail' : ['중대재해발생_재해형태', 'count'],
        'field' : ['중대재해발생_사업장명', 'count'],
        'address' : ['중대재해발생_재해형태', 'count'],
        'field_cat1' : ['중대재해발생_재해형태', 'count'],
        'company' : ['중대재해발생_재해형태', 'count'],
        'project' : ['중대재해발생_재해형태', 'count'],
      },
      data: [{label: '데이터 없음', value: 0}],
    }
  },
  async mounted () {
    await this.loadGraph()
  },
  methods: {
    async loadGraph () {
      const projectIds = this.projectId ? [this.projectId] : []
      const summaryKey = this.summaryKeys[this.dataType]
      const boardIds = this.boardIds
      const dataType = this.dataType
      const dataList = await CircleGraphUtil.loadGraphPieces(this.$store, projectIds, boardIds, summaryKey, dataType)
      let value = {}
      for (const data of dataList) {
        value = CircleGraphUtil.combineCircleGraphData(value, data)
      }
      this.data = CircleGraphUtil.circleModuleWithData(value)
    },
    onClickDetail () {
      const projectId = this.$route.params.proj_id
      const graphId = this.graphId
      if (projectId) {
        this.$router.push(`/project/${projectId}/graph-detail/${graphId}`)
      } else {
        this.$router.push(`/graph-detail/${graphId}`)
      }
    },
    onClickWrite () {
      const proj_id = this.$route.params.proj_id
      const boardId = `${this.boardId}`
      this.$router.push({name: 'write|tab', params: {proj_id, boardId}})
    }
  },
}
</script>

<style scoped>

</style>
